<template>
	<Row class="icons-card-container flex-centerize">
		<AppIcon v-if="integrationIconName" class="workflow-icon" :name="integrationIconName" width="17" />
		<AppIcon class="integration-icon ml-3" name="puzzle-tool" width="20" />
	</Row>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { getPlacement } from '@/store/modules/placements/getters';
import { getService } from '@/store/modules/apps/getters';
export default {
	name: 'ButtonsDropdownIconsCard',
	props: {
		buttonDropdown: { type: Object, required: true },
	},
	computed: {
		...mapGettersShorthand({ getPlacement, getService }),
		integrationIconName() {
			return this.service?.service_slug;
		},
		placement() {
			return this.getPlacement(this.buttonDropdown.placement);
		},
		service() {
			return this.getService(this.placement?.service);
		},
	},
};
</script>

<style scoped lang="scss">
.icons-card-container {
	height: 46px;
	min-width: 80px;
	border-radius: 12px;
	background: var(--bg-color);
	border: 1px solid #abb2bd6e;
	box-shadow: 0px 1px 2px #80899c4d;
}
</style>
